<template>
  <div>
    <H5 v-if="isMobile" :data="piecesDetail" />
    <PC v-else :data="piecesDetail" />
  </div>
</template>

<script lang="ts" setup>
import PC from './components/pc.vue';
import H5 from './components/h5.vue';
import { piecesShare, getPiecesDetail } from '~/api';
const route = useRoute();
const { isMobile } = useDevice();

const { data: piecesDetail } = useAsyncData(async () => {
  const token = route.query.token as string;
  const { data } = await getPiecesDetail({
    task_id: token?.split('_')[1],
    generate_record_xihe_task_id: String(route.params.id),
  });
  return data;
});

watch(
  () => piecesDetail.value,
  data => {
    // console.log('piecesDetail', data);
    if (!data?.id) {
      // console.log('pieces token not valid', route.query.token);
      throw new Error(`pieces token not valid ${route.query.token}`);
    }
  },
);

setPageLayout(isMobile ? 'h5' : 'exposed');

onMounted(() => {
  const token = route.query.token as string;
  if (token) {
    const data = token.split('_');
    if (data.length !== 2) {
      return;
    }
    try {
      piecesShare({
        task_id: data[1],
        from_user_id: parseInt(data[0], 16),
      });
    } catch (error) {
      console.warn('[Pieces] piecesShare error', error);
    }
  }
});
</script>

<style scoped lang="scss"></style>
